import * as model_model_lib from "./libraries/model_lib/index";
import * as client_lib_client_lib from "./libraries/client_lib/index";
import * as control_bundle_lib_control_bundle_lib from "./libraries/control_bundle_lib/index";

export function initialize(object:any, package_root:string='') {
	return {
		'fingerprint': object.fingerprint,
		'language fingerprint': object['language fingerprint'],
		root: init(object['root'], package_root)
	};
}
export function init(object:any, package_root:string) {
	package_root = package_root + 'package';
	const path = '';
	return {
		'client.lib': client_lib_client_lib.init(object['type'][1]['children']['client.lib']['inode']['type'][1]['inode'], package_root + path + '/client.lib/')
		,'collation_table.alan.json': new ManifestFile(package_root + path + '/collation_table.alan.json', package_root + path + '/collation_table.alan.json.symtab')
		,'control-bundle.lib': control_bundle_lib_control_bundle_lib.init(object['type'][1]['children']['control-bundle.lib']['inode']['type'][1]['inode'], package_root + path + '/control-bundle.lib/')
		,'data': undefined
		,'etc': undefined
		,'main.alan': new ManifestFile(package_root + path + '/main.alan' + object['type'][1]['children']['main.alan']['inode']['type'][1].suffix, package_root + path + '/main.alan.symtab')
		,'model': model_model_lib.init(object['type'][1]['children']['model']['inode']['type'][1]['inode'], package_root + path + '/model/')
		,'model.alan': new ManifestFile(package_root + path + '/model.alan' + object['type'][1]['children']['model.alan']['inode']['type'][1].suffix, package_root + path + '/model.alan.symtab')
		,'phrases.alan': new ManifestFile(package_root + path + '/phrases.alan' + object['type'][1]['children']['phrases.alan']['inode']['type'][1].suffix, package_root + path + '/phrases.alan.symtab')
		,'reports': Object.entries<any>(object['type'][1]['children']['reports']['inode']['type'][1]['children']).reduce<Record<string, ReturnType<typeof reports_dynamic_init>>>((result, [key, value]) => {
			result[key] = reports_dynamic_init(value['inode'], package_root, path + '/reports/' + key);
			return result;
		}, {})
		,'settings.alan': new ManifestFile(package_root + path + '/settings.alan' + object['type'][1]['children']['settings.alan']['inode']['type'][1].suffix, package_root + path + '/settings.alan.symtab')
		,'translations': Object.entries<any>(object['type'][1]['children']['translations']['inode']['type'][1]['children']).reduce<Record<string, ReturnType<typeof translations_dynamic_init>>>((result, [key, value]) => {
			result[key] = translations_dynamic_init(value['inode'], package_root, path + '/translations/' + key);
			return result;
		}, {})
		,'views': Object.entries<any>(object['type'][1]['children']['views']['inode']['type'][1]['children']).reduce<Record<string, ReturnType<typeof views_dynamic_init>>>((result, [key, value]) => {
			result[key] = views_dynamic_init(value['inode'], package_root, path + '/views/' + key);
			return result;
		}, {})
		,'widgets': Object.entries<any>(object['type'][1]['children']['widgets']['inode']['type'][1]['children']).reduce<Record<string, ReturnType<typeof widgets_dynamic_init>>>((result, [key, value]) => {
			result[key] = widgets_dynamic_init(value['inode'], package_root, path + '/widgets/' + key);
			return result;
		}, {})
	}

}
export class ManifestFile {
	constructor(readonly path: string, readonly sympath: string) {};
}
function views_dynamic_init(object:any, package_root:string, path:string) {
	return new ManifestFile(package_root + path + '' + object['type'][1].suffix, package_root + path + '.symtab')
}
function reports_dynamic_init(object:any, package_root:string, path:string) {
	return {
		'parameters.alan': new ManifestFile(package_root + path + '/parameters.alan' + object['type'][1]['children']['parameters.alan']['inode']['type'][1].suffix, package_root + path + '/parameters.alan.symtab')
		,'sheets': Object.entries<any>(object['type'][1]['children']['sheets']['inode']['type'][1]['children']).reduce<Record<string, ReturnType<typeof reports_dynamic_sheets_dynamic_init>>>((result, [key, value]) => {
			result[key] = reports_dynamic_sheets_dynamic_init(value['inode'], package_root, path + '/sheets/' + key);
			return result;
		}, {})
	}
}
function reports_dynamic_sheets_dynamic_init(object:any, package_root:string, path:string) {
	return new ManifestFile(package_root + path + '' + object['type'][1].suffix, package_root + path + '.symtab')
}
function translations_dynamic_init(object:any, package_root:string, path:string) {
	return new ManifestFile(package_root + path + '' + object['type'][1].suffix, package_root + path + '.symtab')
}
function widgets_dynamic_init(object:any, package_root:string, path:string) {
	return new ManifestFile(package_root + path + '' + object['type'][1].suffix, package_root + path + '.symtab')
}
